import dayjs from 'dayjs';

/**
 * Checks if two dates are the same
 */
export function isSameDate(dateA, dateB) {
  const parsedDateA = dateA ? dayjs(dateA) : dayjs(null);
  const parsedDateB = dateB ? dayjs(dateB) : dayjs(null);
  return parsedDateA.isSame(parsedDateB, 'days');
}

/**
 * Adds a specified amount of time to a date
 */
export function addDays(date, amount, granularity) {
  const parsedDate = date ? dayjs(date) : dayjs(null);
  return parsedDate.add(amount, granularity);
}

/**
 * Normalizes and clamps the weeksShown value to valid range (1-6)
 */
export function normalizeWeeksShown(weeksShown) {
  if (typeof weeksShown !== 'number' || Number.isNaN(weeksShown)) {
    return 1;
  }
  const floored = Math.floor(weeksShown);
  return Math.max(1, Math.min(6, floored));
}

/**
 * Gets the start and end dates of a week range based on a specified date
 */
export function getWeekRangeDates(date, weeksShown) {
  const parsedDate = dayjs(date);
  const rangeStart = parsedDate.startOf('week');
  const rangeEnd = rangeStart.add(weeksShown * 7 - 1, 'days');
  return { start: rangeStart, end: rangeEnd };
}

/**
 * Formats a date range for display in the ViewChangerButton
 * Returns both visual and ARIA label versions
 */
export function formatWeekRangeTitle(startDate, endDate) {
  const start = dayjs(startDate);
  const end = dayjs(endDate);
  
  const startMonth = start.month();
  const endMonth = end.month();
  const startYear = start.year();
  const endYear = end.year();
  
  // Cross-year range
  if (startYear !== endYear) {
    const visual = `${start.format('MMM')} ${start.format('D')}, ${startYear}–${end.format('MMM')} ${end.format('D')}, ${endYear}`;
    const aria = `${start.format('MMMM')} ${start.format('D')}, ${startYear} to ${end.format('MMMM')} ${end.format('D')}, ${endYear}`;
    return { visual, aria };
  }
  
  // Multi-month range (same year)
  if (startMonth !== endMonth) {
    const visual = `${start.format('MMM')} ${start.format('D')}–${end.format('MMM')} ${end.format('D')}, ${startYear}`;
    const aria = `${start.format('MMMM')} ${start.format('D')} to ${end.format('MMMM')} ${end.format('D')}, ${startYear}`;
    return { visual, aria };
  }
  
  // Single-month range
  const visual = `${start.format('MMMM')} ${start.format('D')}–${end.format('D')}, ${startYear}`;
  const aria = `${start.format('MMMM')} ${start.format('D')} to ${end.format('D')}, ${startYear}`;
  return { visual, aria };
}